import React from "react";

const Dots = ({ style, color = "#232323" }) => (
  <svg
    style={style}
    width="0.17625rem"
    height="0.764583333rem"
    viewBox="0 0 3 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="1.5" cy="1.5" r="1.5" fill={color} />
    <circle cx="1.5" cy="6.5" r="1.5" fill={color} />
    <circle cx="1.5" cy="11.5" r="1.5" fill={color} />
  </svg>
);

export default Dots;
